import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const TYPE_MAP = {
    gold: {
        top: 'https://x0.ifengimg.com/ucms/2022_03/611A40B99B97AA36CF3735AF765378DFA2B47BFA_size72_w1620_h100.png',
        cardBc: 'https://x0.ifengimg.com/ucms/2022_03/CC309A5BEB04BC37A97C881299CD2B0662D23E47_size10_w652_h120.png',
        gradient: 'linear-gradient(134deg, #FFF4E0 0%, #FFE8BC 100%)',
        padgeRight: 'https://x0.ifengimg.com/ucms/2022_03/CA1A5872100FAA8F3B421F37B47B8500264F8E1E_size23_w240_h100.png',
        padgeLeft: 'https://x0.ifengimg.com/ucms/2022_03/9FCE9C319E205172D95B068392F5267C70F146FC_size17_w200_h84.png',
        color: '#8A5021',
        shadow: 'rgba(255, 239, 188, 0.8)'
    },
    silver: {
        top: 'https://x0.ifengimg.com/ucms/2022_03/C122A6255AA30F6ADEA32F46A77561CBB09B5FDC_size68_w1620_h100.png',
        cardBc: 'https://x0.ifengimg.com/ucms/2022_03/F59ABE3FE54D8B8B670CA86626EA8C3BD718BD65_size11_w652_h120.png',
        gradient: 'linear-gradient(134deg, #EAEAEA 0%, #E3E5EF 100%)',
        padgeRight: 'https://x0.ifengimg.com/ucms/2022_03/936AF9A74888217D32E907735B1DF33A3387C2AB_size22_w240_h100.png',
        padgeLeft: 'https://x0.ifengimg.com/ucms/2022_03/D46088A48C301DC748D99A28033108A09BE97B3B_size18_w200_h84.png',
        color: '#575B61',
        shadow: '#C4C6CA'
    },
    copper: {
        top: 'https://x0.ifengimg.com/ucms/2022_03/CFEF996D1D89DEB8DD4AE95D4098F27B0372E47D_size70_w1620_h100.png',
        cardBc: 'https://x0.ifengimg.com/ucms/2022_03/3358C63E5C8BD1FB3B5A96A87BE9F161CC7DC7D3_size9_w652_h120.png',
        gradient: 'linear-gradient(134deg, #FEECE1 0%, #F6D8C6 100%)',
        padgeRight: 'https://x0.ifengimg.com/ucms/2022_03/560D498EB5016B7848C04B2DFE70031DF5DAB019_size23_w240_h100.png',
        padgeLeft: 'https://x0.ifengimg.com/ucms/2022_03/5EF84784A410CD345139A15EE7F61886BB78D1F7_size17_w200_h84.png',
        color: '#814413',
        shadow: '#F7C3A2'
    },
    break: {
        top: 'https://x0.ifengimg.com/ucms/2022_03/1648CC834F083D0FF01BFDC9FDA4C874F97971EC_size75_w1620_h100.png',
        cardBc: 'https://x0.ifengimg.com/ucms/2022_03/141BFBD9809AF08FD7C1762CB0B39A2E2BF0B93B_size9_w652_h120.png',
        gradient: 'linear-gradient(-45deg, #E0EDFE 0%, #EBF4FF 100%)',
        padgeRight: 'https://x0.ifengimg.com/ucms/2022_03/B6A38C735521E18D9C539962772F8C92FE4C5616_size14_w240_h100.png',
        padgeLeft: 'https://x0.ifengimg.com/ucms/2022_03/99343F69B5540DB2CD3B98F0E5EB56199ED66249_size11_w200_h84.png',
        color: '#FFFFFF',
        shadow: 'rgba(21, 120, 242, 0.5)'
    }
};

const Part = (props) => {
    const { type, list } = props;
    const first = list[0];
    const lastList = list.slice(1);
    const extra = lastList.length % 4 === 0 ? 0 : 4 - lastList.length % 4;

    for (let i = 0; i < extra; i++) {
        lastList.push({ isEmpty: true });
    }

    return (
        <div className={styles.box}>
            <img className={styles.top} src={TYPE_MAP[type].top} alt="" />
            <a href={first.url} target="_blank" rel="noreferrer">
                <div className={styles.card}>
                    <div className={styles.imgWp}>
                        <img className={styles.imgPart} src={first.pcPicUrl} alt={first.winner} />
                    </div>
                    <div className={styles.textPart} style={{ backgroundImage: `url(${TYPE_MAP[type].cardBc})` }}>
                        <div className={styles.padge} style={{ backgroundImage: `url(${TYPE_MAP[type].padgeRight})`, color: TYPE_MAP[type].color, textShadow: `0 1px 1px ${TYPE_MAP[type].shadow}` }}>
                            {type === 'break' ? first.rank : list.length}
                        </div>
                        <p className={styles.name}>{first.winner}</p>
                        <p className={styles.project}>{first.gameName}</p>
                        <hr />
                        <div className={styles.content}>
                            {first.description}
                        </div>

                    </div>

                </div>
            </a>
            <div className={styles.awardList}>
                {
                    lastList.map((item, index) => {
                        return (
                            item.isEmpty
                                ? <div className={`${styles.award} ${styles.empty}`} key={index} />
                                :
                                    <a href={item.url} target="_blank" rel="noreferrer" key={index}>
                                        <div className={styles.award} style={{ background: TYPE_MAP[type].gradient }}>
                                            <div className={styles.padge} style={{ backgroundImage: `url(${TYPE_MAP[type].padgeLeft})`, color: TYPE_MAP[type].color, textShadow: `0 1px 1px ${TYPE_MAP[type].shadow}` }}>
                                                {type === 'break' ? item.rank : list.length - index - 1}
                                            </div>
                                            <div className={styles.nameWp}>
                                                <div className={styles.name}>{item.winner}</div>
                                            </div>
                                            <div className={styles.imgWp}>
                                                <img src={item.pcPicUrl} alt={item.winner} />
                                                <div className={styles.text}>{item.gameName}</div>
                                            </div>
                                        </div>
                                    </a>

                        );
                    })
                }
            </div>
        </div>
    );
};

Part.propTypes = {
    type: PropTypes.string,
    list: PropTypes.array
};

export default errorBoundary(Part);
